// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"582": "a697a4e13b332689","846": "4bd430a0b88ea002",}[chunkId] + ".js"
}